<template>
  <section>
    <div class="card">
      <div class="card-header">
        <h4>E-Mail Einstellungen</h4>
      </div>
      <div class="card-body">
        <div class="form-group row">
          <col-label
            >Limitiere offline Tage für E-Mail Benachrichtugung</col-label
          >
          <div class="col-2">
            <div class="custom-control custom-checkbox">
              <input
                class="form-check-input custom-control-input"
                type="checkbox"
                v-model="data.limitOfflineDaysForEmail"
                id="limitOfflineDaysForEmail"
              />
              <label
                class="form-check-label custom-control-label"
                for="limitOfflineDaysForEmail"
                >aktiv</label
              >
            </div>
          </div>
          <div class="col-6">
            <div class="card">
              <div class="card-body">
                <i class="fas fa-question-circle text-info"></i>
                Mitglieder erhalten keine Rundmails und keine Offline
                Benachrichtigungen.
              </div>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <col-label>Max. offline Tage für E-Mail Benachrichtugung</col-label>
          <div class="col-2">
            <input
              type="number"
              class="form-control"
              v-model="data.maxOfflineDaysForEmail"
            />
          </div>
          <div class="col-6">
            <div class="card">
              <div class="card-body">
                <i class="fas fa-question-circle text-info"></i>
                Anzahl der Tage, die ein Mitglied offline sein muss, um keine
                Rundmails und keine Offline Benachrichtigungen zu erhalten.
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div class="form-group row">
          <col-label>Max. Mail Limit</col-label>
          <div class="col-2">
            <input
              type="number"
              class="form-control"
              v-model="data.mailLimitMaxDaily"
            />
          </div>
          <div class="col-6">
            <div class="card">
              <div class="card-body">
                <i class="fas fa-question-circle text-info"></i>
                Anzahl der am Tag versendeten Emails über neue Nachrichten und
                Freundschaftsanfragen.
                <br />
                Betrifft nicht Rundmails.
              </div>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <col-label>Mail Delay in Minuten</col-label>
          <div class="col-2">
            <input
              type="number"
              class="form-control"
              v-model="data.mailLimitUserDelay"
            />
          </div>
          <div class="col-6">
            <div class="card">
              <div class="card-body">
                <i class="fas fa-question-circle text-info"></i>
                Minuten, zwischen dem versendeten von Benachrichtigungs-E-Mails
                bzgl. neue Nachrichten und Freundschaftsanfragen.
                <br />
                Betrifft nicht Rundmails.
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div class="form-group row">
          <col-label>Ruhezeit start in Stunden</col-label>
          <div class="col-2">
            <input
              type="number"
              class="form-control"
              v-model="data.mailLimitSleepStart"
            />
          </div>
          <div class="col-6">
            <div class="card">
              <div class="card-body">
                <i class="fas fa-question-circle text-info"></i>
                Zeitraum indem keine E-Mails über neue Nachrichten und
                Freundschaftsanfragen versendet werden.
                <br />
                Die Emails werden gespeichert und nach diesem Zeitraum
                versendet.
                <br />
                Betrifft nicht Rundmails.
              </div>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <col-label>Ruhezeit ende in Stunden</col-label>
          <div class="col-2">
            <input
              type="number"
              class="form-control"
              v-model="data.mailLimitSleepEnd"
            />
          </div>
        </div>
        <hr />
        <div class="form-group row">
          <col-label>E-Mail Zusammenfassung nach X Tagen</col-label>
          <div class="col-2">
            <input
              type="number"
              class="form-control"
              v-model="data.mailLimitOfflineSummary"
            />
          </div>
          <div class="col-6">
            <div class="card">
              <div class="card-body">
                <i class="fas fa-question-circle text-info"></i>
                E-Mails über neue Nachrichten und Freundschaftsanfragen werden
                wöchentlich zusammengefasst.
                <br />
                Betrifft nicht Rundmails.
              </div>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <col-label>E-Mails deaktivieren nach X Tagen</col-label>
          <div class="col-2">
            <input
              type="number"
              class="form-control"
              v-model="data.mailLimitOfflineDisable"
            />
          </div>
          <div class="col-6">
            <div class="card">
              <div class="card-body">
                <i class="fas fa-question-circle text-info"></i>
                Mitglieder erhält keine E-Mails über neue Nachrichten und
                Freundschaftsanfragen.
                <br />
                Betrifft nicht Rundmails.
              </div>
            </div>
          </div>
        </div>
        <v-button @click.native="persist()" class="btn btn-primary float-right"
          >speichern</v-button
        >
      </div>
    </div>
  </section>
</template>
<script>
import "bootstrap";
export default {
  created() {
    this.$store.dispatch("setting/all").then(() => {
      this.data = this.$store.getters["setting/all"];
    });
  },
  methods: {
    persist() {
      const data = Object.assign({}, this.data);
      this.$store.dispatch("setting/update", data).then(() => {
        this.$notify({
          title: "Einstellungen gespeichert",
          type: "success"
        });
      });
    }
  },
  data() {
    return {
      data: {
        maxOfflineDaysForEmail: "",
        mailLimitMaxDaily: "",
        mailLimitUserDelay: "",
        mailLimitSleepStart: "",
        mailLimitSleepEnd: "",
        mailLimitOfflineSummary: "",
        mailLimitOfflineDisable: "",
        limitOfflineDaysForEmail: ""
      }
    };
  }
};
</script>
